import type { BusinessSubscription } from "lens-platform-sdk";
import { LensSDKException } from "lens-platform-sdk";
import { useQuery } from "@tanstack/react-query";
import { useLensPlatformClient } from "./useLensPlatformClient";

/**
 * Get user's business entity (Lens Business IDs)'s subscriptions by business entity ID.
 */
export const useGetBusinessSubscriptions = (businessId?: string) => {
  const lensPlatformClient = useLensPlatformClient();

  const {
    isLoading: loading, error, data: businessSubscriptions, refetch
  } = useQuery<BusinessSubscription[], LensSDKException>({
    queryKey: ["businessSubscriptions", businessId],
    queryFn: async () => (businessId ? lensPlatformClient.business.getSubscriptions(businessId) : []),
    initialData: []
  });

  return {
    loading,
    error,
    businessSubscriptions,
    reload: refetch
  };
};
